export default "__VITE_ASSET__b556d5ef__"